import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { AlertService } from '../../components/alert';

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { RequestColumnData } from '../../interfaces/employee.model';
import { ChangeBenefitsService } from '../../services/change-benefits/change-benefits.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import {
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoModalComponent } from '../../components/info-modal/info-modal.component';

const ICO_CALENDAR =
`
  <svg width="15" height="15" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3333 1.6665V4.99984M5.66667 1.6665V4.99984M1.5 8.33317H16.5M3.16667 3.33317H14.8333C15.7538 3.33317 16.5 4.07936 16.5 4.99984V16.6665C16.5 17.587 15.7538 18.3332 14.8333 18.3332H3.16667C2.24619 18.3332 1.5 17.587 1.5 16.6665V4.99984C1.5 4.07936 2.24619 3.33317 3.16667 3.33317Z" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`
const ICO_DOWNLOAD =
`
  <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 11.5V14.8333C16.5 15.2754 16.3244 15.6993 16.0118 16.0118C15.6993 16.3244 15.2754 16.5 14.8333 16.5H3.16667C2.72464 16.5 2.30072 16.3244 1.98816 16.0118C1.67559 15.6993 1.5 15.2754 1.5 14.8333V11.5M4.83333 7.33333L9 11.5M9 11.5L13.1667 7.33333M9 11.5V1.5" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`

const ICO_CHECK =
  `
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6667 7.38668V8.00001C14.6659 9.43763 14.2004 10.8365 13.3396 11.9879C12.4788 13.1393 11.2689 13.9817 9.89028 14.3893C8.51166 14.7969 7.03821 14.7479 5.68969 14.2497C4.34116 13.7515 3.18981 12.8307 2.40735 11.6247C1.62488 10.4187 1.25323 8.99205 1.34783 7.55755C1.44242 6.12305 1.99818 4.75756 2.93223 3.66473C3.86628 2.57189 5.12856 1.81027 6.53083 1.49344C7.9331 1.17662 9.40022 1.32157 10.7134 1.90668M14.6667 2.66668L8.00004 9.34001L6.00004 7.34001" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const ICO_CLOCK =
`
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00004 4.00004V8.00004L10.6667 9.33337M14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00004C1.33337 4.31814 4.31814 1.33337 8.00004 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004Z" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`

@Component({
  selector: 'unico-people-employee-requests',
  templateUrl: './employee-requests.component.html',
  styleUrls: ['./employee-requests.component.scss'],
  providers: [
    {
      provide: MAT_DATE_LOCALE, useValue: 'pt-BR'
    }
  ],
})

export class EmployeeRequestsComponent implements OnInit {
  displayedColumns: string[] = ['DocumentTitle', 'EmployeeName', 'EmployeeIdentificator', 'EmployeeCode', 'RequestedAt', 'Status'];

  constructor(
    public alertService: AlertService,
    private changeBenefitsService: ChangeBenefitsService,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer
    ) {
    iconRegistry.addSvgIconLiteral('check_icon', sanitizer.bypassSecurityTrustHtml(ICO_CHECK));
    iconRegistry.addSvgIconLiteral('clock_icon', sanitizer.bypassSecurityTrustHtml(ICO_CLOCK));
    iconRegistry.addSvgIconLiteral('download_icon', sanitizer.bypassSecurityTrustHtml(ICO_DOWNLOAD));
    iconRegistry.addSvgIconLiteral('calendar_icon', sanitizer.bypassSecurityTrustHtml(ICO_CALENDAR));
  }
  @Input() set openMenu(open: boolean) { this.showSidebar = open; }
  @Output() menu = new EventEmitter<boolean>();

  columns: Array<RequestColumnData> = [];
  showSidebar:boolean = false;
  activeColumns: number;
  list$: Observable<any>;
  error$ = new Subject<any>();

  options = {
    autoClose: false,
    keepAfterRouteChange: false
  };

  paginator: any = {
    page: 1,
    limit: 10,
    total: 0
  };

  tabs: Array<string> = ['DONE', 'REQUESTED'];
  selectedTab: string = this.tabs[0];
  searchInput: string;

  today = new Date();
  day = this.today.getDate();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDayRange = new Date(this.year, this.month - 1, this.day);
  endDayRange = new Date(this.year, this.month, this.day);
  range = new FormGroup({
    start: new FormControl(this.startDayRange),
    end: new FormControl(this.endDayRange)
  });

  params = {fields: [], filters: {}};
  reportID: any;
  loadingReport:boolean = false;

  ngOnInit() {
    this.searchBenefitsChangesRequests();
  }

  /**
   * handle the report parameters
   */
  getExportReportParams() {
    const fromWithoutTimezoneHours = this.range.value.start.toISOString().substring(0,10);
    const toWithoutTimezoneHours = this.range.value.end.toISOString().substring(0,10);

    return {
      fields: this.columns.filter((column) => column.Active),
      filters: {
        from: `${fromWithoutTimezoneHours}T00:00:00.000Z`,
        to: `${toWithoutTimezoneHours}T23:59:59.999Z`,
        search: this.searchInput,
        status: this.selectedTab,
        type: "TRANSPORT"
      }
    }
  }
  
  /**
   * Export report request
   */
  exportReport() {
    this.params = this.getExportReportParams();
    this.loadingReport = true;

    this.changeBenefitsService.requestReport(this.params).pipe(
      shareReplay(1),
      catchError(err => {
        this.error$.next(err);
        this.openDialog('', true);
        return of(err);
      })
    ).subscribe(res => {
      this.toggleMenu();
      this.loadingReport = false;
      this.openDialog(res.data.Email, false);
      this.alertService.info(
        'info_icon',
        'O relatório está em processamento'
      );
    });
  }

  /**
   * Open dialog modal
   */
  openDialog(email: string, error: boolean) {
    this.dialog.open(InfoModalComponent, {
      data: {
        email: email,
        error: error
      }
    });
  }

  /**
   * Opens and close side bar
   */
  toggleMenu(): void {
    if (this.columns.length === 0) this.getColumnsData();
    this.showSidebar = !this.showSidebar;
    this.menu.emit(this.showSidebar);
  }

  /**
   * Get columns data
   */
  getColumnsData(): void {
    this.changeBenefitsService.listColumns().pipe(
      catchError(err => {
        this.error$.next(err);
        return of(err);
      })
    ).subscribe(res => {
      this.activeColumns = this.getActiveColums(res.data);
      this.columns = res.data;
    });
  }

  /**
   * Active/inactive a column
   */
  toggleColumn (column) {
    column.Active = !column.Active;
    this.activeColumns = this.getActiveColums(this.columns);
  }

  /**
   * Get active columns number
   */
  getActiveColums (columns): number {
    return columns?.filter((column => column.Active))?.length || 0;
  }

  /**
   * Change selected tab and search
   */
  changeTab(event): void{
    this.selectedTab = this.tabs[event.index];
    this.searchBenefitsChangesRequests();
  }

  /**
   * Set Params for search benefits changes request
   */
  setParams() {
    const fromWithoutTimezoneHours = this.range.value.start.toISOString().substring(0,10);
    const toWithoutTimezoneHours = this.range.value.end.toISOString().substring(0,10);

    const params = {
      from: `${fromWithoutTimezoneHours}T00:00:00.000Z`,
      to: `${toWithoutTimezoneHours}T23:59:59.999Z`,
      search: this.searchInput,
      status: this.selectedTab,
      page: this.paginator.page,
      pageSize: this.paginator.limit,
      documentType: 'TRANSPORT'
    }

    Object.keys(params).forEach(objectKey => !params[objectKey] && delete params[objectKey]);

    return params;
  }

  /**
   * Set search input value
   */
  search(search: string): void {
    this.searchInput = search ?? null;
    this.searchBenefitsChangesRequests();
  }

  /**
   * Reset search
   */
  resetListState(): void {
    this.list$ = null;
    this.error$.next(null);
  }

  /**
   * Search benefits change requests
   */
  searchBenefitsChangesRequests(): void {
    this.resetListState();
    const data = this.setParams();

    this.list$ = this.changeBenefitsService.listChangeBenefitsRequests(data).pipe(
      shareReplay(1),
      map((res) => res.data),
      tap((res) => this.paginator.total = res?.total),
      catchError(err => {
        console.log(err);
        this.error$.next(err);
        return of();
      })
    );
  }

  /**
   * Change page event
   */
  getPage(page: number): void {
    this.paginator.page = page;
    this.router.navigate(['/requests'], {
      queryParams: { status: this.selectedTab, page: page }
    });
    this.searchBenefitsChangesRequests();
  }

  /**
   * Change items per page event
   */
  getPageForLimit(limit: number): void {
    this.paginator.limit = limit;
    this.paginator.page = 1;
    this.router.navigate(['/requests'], {
      queryParams: { status: this.selectedTab, page: this.paginator.page }
    });
    this.searchBenefitsChangesRequests();
  }
}
